import numeral from 'numeral';
import { computed, ref } from 'vue';
import { useTypedStore } from '@/store';

export const useFormatCurrency = () => {
  //#region const
  const store = useTypedStore();
  //#endregion

  //#region data
  const currencyCode = ref<string>();
  const defaultCurrency = ref('$');
  //#endregion

  //#region computed
  const currencies = computed(() => store.getters['misc/currencies']);
  const activeCustomerCurrency = computed(() => store.getters['misc/activeCustomerCurrency']);
  const customerCurrencies = computed(() => store.getters['misc/customerCurrencies']);
  const defaultCurrencyCode = computed(() => {
    return activeCustomerCurrency.value.code || '';
  });
  const currencyLabel = computed(() => {
    if (currencyCode.value === undefined) {
      return defaultCurrency.value;
    }

    const currency = currencies.value.find(((el) => el.code === currencyCode.value));

    return currency?.symbol || `${currencyCode.value} `;
  });
  //#endregion

  //#region methods
  const formatCurrency = (value: number) => {
    return `${currencyLabel.value}${value < 0 ? '-' : ''}${numeral(Math.abs(value)).format('0,0.00')}`;
  };
  const formatMetric = (metric: any, _currencyLabel = currencyLabel.value) => {
    return {
      ...metric,
      ...(_currencyLabel && {
        title: metric.title.replace(/, \$|, {{ currencyCode }}/, `, ${_currencyLabel}`),
        title_short: metric.title.replace(/, \$|, {{ currencyCode }}/, `, ${_currencyLabel}`),
      }),
    };
  };

  const checkCurrencyCode = (code: string) => {
    if (code && customerCurrencies.value.find((currency) => currency.code === code)) {
      return code;
    }

    return defaultCurrencyCode.value;
  };
  //#endregion

  return {
    currencyCode,
    defaultCurrency,

    currencies,
    activeCustomerCurrency,
    customerCurrencies,
    defaultCurrencyCode,
    currencyLabel,

    formatCurrency,
    formatMetric,
    checkCurrencyCode,
  };
};

// TODO: проследить где используется и убрать
// props: {
//   propCurrencyCode: {
//     type: String,
//     default: '',
//   },
// },
